import { render, staticRenderFns } from "./birthdayWel.vue?vue&type=template&id=7a5db82b&scoped=true"
import script from "./birthdayWel.vue?vue&type=script&lang=js"
export * from "./birthdayWel.vue?vue&type=script&lang=js"
import style0 from "./birthdayWel.vue?vue&type=style&index=0&id=7a5db82b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5db82b",
  null
  
)

export default component.exports